
import {
    FETCH_SE_ANALYTIC_REQUEST,
    FETCH_SE_ANALYTIC_SUCCESS,
    FETCH_SE_ANALYTIC_FAILURE
} from '../../../../../Constants/actionTypes';

const initialState = {
    loading: false,
    result: [],
    error: null,
};

const salesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SE_ANALYTIC_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_SE_ANALYTIC_SUCCESS:
            return { ...state, loading: false, result: action.payload };
        case FETCH_SE_ANALYTIC_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default salesReducer;
